const SURNAME_PREFIXES = [
  'van',
  'van de',
  'van der',
  'de',
  'den',
  'der',
  'ten',
  'ter',
  'te',
];

export function getInitials(firstName: string, lastName: string): string {
  if (!firstName && !lastName) return '';

  const firstInitial = firstName.trim().charAt(0).toUpperCase();

  const lastNameParts = lastName.toLowerCase().trim().split(/\s+/);

  let surnameCore = lastNameParts[lastNameParts.length - 1];

  // Detect multi-word prefixes (van der, van de, ...)
  for (const prefix of SURNAME_PREFIXES) {
    const prefixParts = prefix.split(' ');
    const lastParts = lastNameParts.slice(0, prefixParts.length);

    if (lastParts.join(' ') === prefix) {
      surnameCore = lastNameParts[prefixParts.length];
      break;
    }
  }

  const lastInitial = surnameCore?.charAt(0).toUpperCase() ?? '';

  return `${firstInitial}${lastInitial}`;
}
``;
